/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-27 15:27:59
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-12-25 11:33:38
 * @FilePath: \qcloud-web-pc-4.0\src\components\page-header\lang\cn.js
 * @Description: 底部
 */
const page_footer = {
  follow: '关注我们',
  wechat: '官方公众号',
  user: '用户类型',
  first: '初次接触',
  forStudent: '学生',
  forEducator: '教育工作者',
  forDeveloper: '开发人员',
  forCompany: '企业',
  union: '产业联盟',
  solution: '行业解决方案',
  chemiq: '生物化学',
  educate: '量子教育',
  finance: '金融科技',
  bigData: '大数据',
  power:'电力行业',
  ai: '人工智能',
  engineering: '工程设计',
  pro_serve: '产品服务',
  superQuantum: '悟源超导量子计算机',
  quantumChip: '夸父系列超导量子处理器',
  control_instrumentation: '量子计算专用测控仪器',
  cal_servies: '真实量子计算服务',
  app_serve: '行业应用服务',
  learn_pro: '溯知教育产品',
  learn: '学习',
  course: '教育课程',
  learn_machine: '学习机',
  teach_platfrom: '教研一体化平台',
  doc_center: '文档中心',
  contest: '量子计算编程挑战赛',
  forum: '社区',
  company: '公司',
  about: '关于本源量子',
  newslist: '新闻资讯',
  recruit: '职位信息',
  OriginqInformation: 'Copyright © 2017 - {{year}} Origin Quantum. All Rights Reserved. 本源量子版权所有',
  copyRight: '版权所有',
  areaOriginqInfo: '皖ICP备 17025557号-1',
  areaOriginqText: '皖公网安备 34011102000802号',
  aboutOrgin: '关于本源',
  originLearningMechine: '本源量子学习机',
  officalPublicNumber: '官方公众号',
  officalBlog: '官方微博',
  OriginqService: '《服务协议》',
  OriginqPrivacy: '《隐私政策》',
  footer_desc: '本源量子计算云平台聚焦于量子计算云服务，为用户提供学习资源、编程工具、算力服务、应用开发等全流程服务，致力于推动量子计算的创新和应用，探索量子计算的无限潜力。',
  service:'服务',
  service_quantum:'量子计算服务',
  service_lh:'融合计算服务',
  service_special: '专用量子云平台',
  tools:'编程工具',
  Qpanda:'QPanda',
  VQNet:'VQNet',
  pqypanda:'pyqpanda-algorithm',
  qrunes:'QRunes',
  qurator:'Qurator',
  application:'量子应用',
  finitch:'金融科技',
  bio:'生物医药',
  artifical:'人工智能&大数据',
  info:'信息安全',
  other: '其他',
  learnSource:'学习资源',
};
export default page_footer;
